module.exports = {
  emailRegex: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
  passwordRegex: /^(?=.*[A-Z])(?=.*\d).{9,}$/,
  phoneNoRegex: /^\d{9,}$/,
};
